module.exports = __webpack_public_path__ + "static/media/23.9130dab1.jpg";